import type { ReactNode } from 'react'
import { Eyebrow } from './Eyebrow'
import styles from './Stat.module.css'

export type StatTone = 'default' | 'brass' | 'win' | 'loss' | 'muted'
export type StatSize = 'sm' | 'md' | 'lg' | 'xl'

export interface StatProps {
  label: ReactNode
  value: ReactNode
  tone?: StatTone
  size?: StatSize
  /* Label and value on one line (compact rails). */
  layout?: 'stack' | 'row'
  align?: 'left' | 'center'
}

const toneClass: Record<StatTone, string | undefined> = {
  default: undefined,
  brass: styles.toneBrass,
  win: styles.toneWin,
  loss: styles.toneLoss,
  muted: styles.toneMuted,
}

const sizeClass: Record<StatSize, string> = {
  sm: styles.valueSm, md: styles.valueMd, lg: styles.valueLg, xl: styles.valueXl,
}

/* One labelled number: bankroll, hands played, accuracy. */
export function Stat({ label, value, tone = 'default', size = 'md', layout = 'stack', align = 'left' }: StatProps) {
  const cls = [styles.stat, layout === 'row' && styles.row, align === 'center' && styles.alignCenter]
    .filter(Boolean).join(' ')
  return (
    <div className={cls}>
      <Eyebrow as="span">{label}</Eyebrow>
      <span className={[styles.value, sizeClass[size], toneClass[tone]].filter(Boolean).join(' ')}>{value}</span>
    </div>
  )
}

export interface StatsRailProps {
  direction?: 'column' | 'row'
  children: ReactNode
}

/* Vertical (or wrapped horizontal) list of Stats; sits inside a Panel. */
export function StatsRail({ direction = 'column', children }: StatsRailProps) {
  return <div className={[styles.rail, direction === 'row' && styles.railRow].filter(Boolean).join(' ')}>{children}</div>
}
